var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H27.2C31.6804 0 33.9206 0 35.6319 0.871948C37.1372 1.63893 38.3611 2.86278 39.1281 4.36808C40 6.07937 40 8.31958 40 12.8V27.2C40 31.6804 40 33.9206 39.1281 35.6319C38.3611 37.1372 37.1372 38.3611 35.6319 39.1281C33.9206 40 31.6804 40 27.2 40H12.8C8.31958 40 6.07937 40 4.36808 39.1281C2.86278 38.3611 1.63893 37.1372 0.871948 35.6319C0 33.9206 0 31.6804 0 27.2V12.8Z",
    fill: "#253348"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_11208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.835 17.5841C26.2492 17.5841 26.585 17.9199 26.585 18.3341V20.0011C26.5848 23.3831 24.0344 26.1697 20.752 26.5421V27.5841H23.335C23.7492 27.5841 24.085 27.9199 24.085 28.3341C24.0849 28.7483 23.7492 29.0841 23.335 29.0841H16.668C16.2539 29.0839 15.918 28.7482 15.918 28.3341C15.918 27.92 16.2539 27.5843 16.668 27.5841H19.252V26.5421C15.9694 26.1699 13.4181 23.3832 13.418 20.0011V18.3341C13.418 17.92 13.7539 17.5843 14.168 17.5841C14.5822 17.5841 14.918 17.9199 14.918 18.3341V20.0011C14.9182 22.8084 17.1946 25.0841 20.002 25.0841C22.8091 25.0839 25.0848 22.8083 25.085 20.0011V18.3341C25.085 17.9199 25.4208 17.5841 25.835 17.5841ZM20.002 10.9171C21.7966 10.9173 23.2518 12.3724 23.252 14.1671V20.0011C23.2518 21.7958 21.7966 23.2509 20.002 23.2511C18.2071 23.2511 16.7521 21.7959 16.752 20.0011V14.1671C16.7521 12.3723 18.2071 10.9171 20.002 10.9171ZM20.002 12.4171C19.0356 12.4171 18.2521 13.2008 18.252 14.1671V20.0011C18.2521 20.9674 19.0356 21.7511 20.002 21.7511C20.9682 21.7509 21.7518 20.9673 21.752 20.0011V14.1671C21.7518 13.2009 20.9682 12.4173 20.002 12.4171Z",
    fill: "#5BA8F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_11208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.6a6a1bcc9156d5a9f33cf3020e403aa1.svg";
export { ForwardRef as ReactComponent };